import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';

import InvestmentTransactionEditForm from 'components/Forms/InvestmentTransactionEditForm';

import InvestmentTransactionEditSurface from './InvestmentTransactionEditSurface';
import { useInvestmentTransactionEditActions } from '../hooks/useInvestmentTransactionEditActions';
import type { InvestmentTransactionEditViewProps } from '../types';

export default function InvestmentTransactionEditDialogView({
  transaction,
  dialogId,
  context,
  rootModalDrawer,
  ...dialogProps
}: InvestmentTransactionEditViewProps): React.JSX.Element {
  const { closeForm, deleteTransaction, isDirty, submitForm } = useInvestmentTransactionEditActions({
    context,
    dialogId,
    rootModalDrawer,
    transaction,
  });
  const title = transaction?.id ? 'Transaction detail' : 'Create transaction';

  return (
    <InvestmentTransactionEditSurface
      {...dialogProps}
      dialogId={dialogId}
      onClose={closeForm}
      rootModalDrawer={rootModalDrawer}
      title={title}
    >
      <DialogContent sx={rootModalDrawer ? { flex: '1 1 auto', minHeight: 0 } : undefined}>
        <InvestmentTransactionEditForm transaction={transaction} />
      </DialogContent>
      <DialogActions>
        {transaction?.id ? (
          <Button id='investment-transaction-delete-button' color='error' onClick={deleteTransaction}>
            Delete
          </Button>
        ) : null}
        <Button
          variant='contained'
          disabled={!isDirty}
          onClick={submitForm}
          id='investment-transaction-edit-submit-button'
        >
          {transaction?.id ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </InvestmentTransactionEditSurface>
  );
}
